/*
  This file is auto-generated by `pnpm run registerIntegrations`
  !!! Do not edit this file manually !!!
*/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _default = [];
